import React from "react";

const PauseBig = () => {
  return (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 9.5V38.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M30.5 9.5V38.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
  )
}

export default PauseBig;
